// Stateful cloud advected through the field. This is the topology that flips
// the engine from pure f(x, y, t) to a simulation — 14 of the 82 chapters.
import { mulberry32 } from '../rng.js'

export default {
  id: 'particles',
  label: 'Particles',
  motion: 'advect',
  params: [
    { key: 'density', label: 'count', tier: 'structural', min: 8, max: 80, step: 1, default: 44 },
    { key: 'step', label: 'step size', tier: 'continuous', min: 0.001, max: 0.03, step: 0.0005, default: 0.0055 },
    { key: 'lifespan', label: 'lifespan', tier: 'continuous', min: 20, max: 400, step: 5, default: 120 },
  ],

  build(cfg, seed) {
    const rnd = mulberry32(seed)
    const total = Math.min(4000, Math.round(cfg.density * cfg.density * 0.5))
    // x, y, z, age, life. z is carried but never integrated: the fields are
    // 2D, so nothing steers in depth yet. A 3D field writes it without the
    // motion stage or the draw list changing shape.
    const state = new Float32Array(total * 5)
    for (let i = 0; i < total; i++) {
      const o = i * 5
      state[o] = rnd() * 2 - 1
      state[o + 1] = rnd() * 2 - 1
      state[o + 2] = 0
      state[o + 3] = rnd() * cfg.lifespan
      state[o + 4] = cfg.lifespan * (0.5 + rnd())
    }
    // Respawn needs its own stream so it does not consume the build stream and
    // make the opening frame depend on how long the piece has been running.
    // No runs: an advected cloud has no ordering to stroke along. A path
    // mark on this substrate draws nothing, which is the honest answer.
    return { state, count: total, rnd: mulberry32(seed ^ 0x5bf03635), runs: null, closed: false }
  },
}
